import { COLLECT_REPORT } from '@/api/apiModules'
import dictionary from '@/utils/dictionary'
export default {
  module: COLLECT_REPORT,
  params: null,
  toolbar: {
    hasToolbar: false
  },
  fillDetailUrl: `${COLLECT_REPORT}/peripheral/detail`,
  viewType: 'form',
  cb() {},
  view: {
    isSimple: false,
    labelWidth: '120px',
    header: {},
    content: [
      {
        isGroup: true,
        $type: 'group',
        $id: 'base',
        // title: '详情',
        $items: [
          {
            $id: 'name',
            label: '外设名称'
          },
          {
            $id: 'type',
            label: '类型'
          },
          {
            $id: 'interfaceType',
            label: '接口类型'
          },
          {
            $id: 'manufacturer',
            label: '制造商'
          },
          {
            $id: 'hardwareCode',
            label: '硬件编码'
          },
          {
            $id: 'description',
            label: '备注说明'
          },
          {
            $id: 'updateTime',
            label: '更新时间',
            dataType: 'date'
          },
          {
            $id: 'compat',
            label: '兼容信息',
            dataType: 'custom',
            custom: function(row, h) {
              if (!row) {
                return
              }
              var itemArr = []
              for (let index = 0; index < row.compat.length; index++) {
                const element = row.compat[index]
                var rowClass = 'wsp-display-flex wsp-line-height-28 wsp-text-align-center'
                if (index !== row.compat.length - 1) {
                  rowClass = rowClass + ' wsp-border-bottom'
                }
                itemArr.push(
                  <div class={rowClass}>
                    <div class="wsp-width-30 wsp-text-align-center wsp-border-right">{element.productVersion}</div>
                    <div class="wsp-width-20  wsp-border-right">
                      <el-tag type={dictionary['compatibleStatus'][element.compatibleStatus]['type']}>
                        {dictionary['compatibleStatus'][element.compatibleStatus]['label']}
                      </el-tag>
                    </div>
                    <div class="wsp-width-50">{element.limitDesc}</div>
                  </div>
                )
              }

              return <div>{itemArr}</div>
            }
          }
        ]
      }
    ]
  }
}
